{
  "settings_account_page": {
    "title": "Account",
    "company_info": {
      "header": "Company Information",
      "labels": {
        "company_name_label": "Company Name",
        "company_website_label": "Company Website URL",
        "site_id_label": "Site ID"
      }
    },
    "personal_info": {
      "header": "Personal Information",
      "labels": {
        "name": "Name",
        "email": "Email Address"
      }
    },
    "update_account_notice": {
      "title": "Updating your account",
      "description": "You can change your name and email below. For any other changes to your account, including deleting it, you'll need to speak to our team."
    }
  },
  "settings_password_page": {
    "warning": "Please speak to the team owner to modify password details."
  },
  "settings_team_page": {
    "title": "Team",
    "subtitle": "Teams let you invite others to access this SparkLayer account.",
    "footer": "Learn more about teams",
    "no_access": "Please speak to a team owner to modify team details.",
    "owner": {
      "header": "Team Owner"
    },
    "members": {
      "header": "Team Members"
    },
    "invite_member": "If you're the Team Owner, you can invite people to collaborate on your SparkLayer account.",
    "empty": {
      "title": "",
      "subtitle": "Invite people to collaborate on your SparkLayer account.",
      "invite_member_button": "Invite a team member"
    }
  },
  "invite_member_page": {
    "title": "Invite a new member",
    "no_access": "Please speak to a team owner to invite a new member.",
    "form_header": "Details",
    "role_label": "Role",
    "roles": {
      "full": {
        "label": "Full Access",
        "description": "Ideal for other members of your team. All pages can be viewed including the ability to update settings."
      },
      "restricted": {
        "label": "Restricted Access",
        "description": "Ideal for technical implementation partners. Orders and activity pages can be viewed and configuration settings can be updated."
      }
    }
  },
  "plan_page": {
    "title": "Billing",
    "subtitle": "Current Plan",
    "billing_duration": {
      "year": "Annual price",
      "default": "Monthly price"
    },
    "billing_info": {
      "stripe": "You are being billed via Stripe, you can view any invoices or payment details using the buttons above or contact us for any queries.",
      "shopify": "You are being billed via Shopify, please check Shopify billing for any queries.",
      "hubspot": "You are being billed manually, please contact us with any queries.",
      "wix": "You are being billed via Wix, please check Wix billing for any queries."
    },
    "alerts": {
      "no_permission": "Please speak to the team owner to modify billing.",
      "test_mode": "To view your plan details, please turn off Test mode.",
      "partner": "As a SparkLayer partner, you have access to our free plan. To manage your customers, simply click the menu on the top left.",
      "connect_no_plan": {
        "body": "Please connect your website to choose a plan or contact us to enable the Enterprise plan.",
        "link": "Contact us.",
        "cta": "Connect your website"
      },
      "connect_plan": {
        "body": "Please connect your platform.",
        "cta": "Connect your platform"
      },
      "linked": {
        "body": "This account is linked to another billing account.",
        "cta": "Go to linked billing account"
      }
    },
    "plans": {
      "title": "Explore Plans",
      "action": "Change Plan",
      "basic_plan": {
        "body": "Need to scale back? Our basic plan is free - it covers up to 3 price lists and 5 orders a month.",
        "button": "Switch to the free plan"
      }
    },
    "addons": {
      "sales_agents": {
        "title": "Sales Agent Ordering",
        "price": "$39 per agent (per month)",
        "body": "Empower your sales team to place orders on behalf of your customers and manage their accounts."
      },
      "quoting": {
        "title": "Quoting",
        "price": "$49 per month",
        "body": "Enable an end-to-end \"quote to order\" experience and unify your sales team and B2B customers. "
      },
      "analytics": {
        "title": "SparkLayer Analytics",
        "price": "Custom pricing",
        "body": "Unlock the true potential of your B2B eCommerce business with our advanced analytics platform."
      }
    }
  }
}
